import api from "./api.js";
import { Url_Pdf, Url_Pdf_Info } from "../assets/URL'S/Url_Pdf.js";
import User from "./user";

export const progressaoService = {
  listarCursos: async () => {
    const res = await api.get(`/${User.perfil()?.toLowerCase()}/listar-cursos-rh`);
    return res.data.map((value) => ({
      label: value.nome,
      value: value.id + "," + value.nome,
    }));
  },

  listarTurmas: async (cursoId) => {
    const res = await api.get(`/professor/listar-turmas-rh?id=${cursoId}`);
    return res.data.map((value) => ({
      label: value.nome.split("-").slice(1).join(" - ").trim(),
      value: value.id + "," + value.nome,
    }));
  },

  getDisciplina: async (turmaId) => {
    const res = await api.get(`/professor/listar-disciplina-rh?idTurma=${turmaId}`);
    return res.data.map((value) => ({
      label: value.disciplina,
      value: value.id_disciplina + "," + value.disciplina,
    }));
  },

  listarAlunos: async (cursoId) => {
    const res = await api.get(`/professor/listar-alunos?id=${cursoId}`);
    return res.data;
  },

  listarAlunosProgressoes: async (idProgressao) => {
    const res = await api.get(`/professor/listar-alunos-progressoes?id_progressao=${idProgressao}`);
    return res.data.alunosEmProgressao.filter(Boolean).flat();
  },

  enviarAlunoParaBackend: async (data) => {
    const res = await api.put("/professor/selecionar-aluno", data);
    return res;
  },

  cadastrarProgressao: async (formData) => {
    const res = await api.post("/professor/cadastrar-progressao", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res;
  },

  editarProgressao: async (formData) => {
    const res = await api.put("/professor/editar-progressao", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res;
  },

  getPdf: async (pdfName) => {
    const res = await api.get(Url_Pdf(pdfName), { responseType: "arraybuffer" });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const file = new File([blob], `${pdfName}.pdf`, { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const { data } = await api.get(Url_Pdf_Info(pdfName));
    return { url, file, fileSize: data };
  },

  enviarProgressaoAluno: async (formData) => {
    console.log(
      "3- Submitting formData:",
      formData.get("file"),
      formData.get("observacao"),
      formData.get("id_progressao")
    );
    const res = await api.put("/aluno/enviar-progressao", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res;
  },
};
